import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-support-ticket-activity-renderer',
  template: `
    <div class="activity-cell d-flex align-items-center h-100 ps-2" *ngIf="label !== '-'">
      <span class="activity-pill" [ngClass]="pillClass">{{ label }}</span>
    </div>
    <div class="ps-2 text-muted" *ngIf="label === '-'">-</div>
  `,
  styles: [`
    .activity-pill {
      display: inline-flex;
      align-items: center;
      padding: 0.15rem 0.55rem;
      border-radius: 999px;
      font-size: 0.75rem;
      font-weight: 600;
      white-space: nowrap;
      line-height: 1.4;
    }
    .activity-new {
      background: #fff7ed;
      color: #c2410c;
      border: 1px solid #fdba74;
    }
    .activity-pending {
      background: #eff6ff;
      color: #1d4ed8;
      border: 1px solid #93c5fd;
    }
    .activity-replied {
      background: #ecfdf5;
      color: #047857;
      border: 1px solid #6ee7b7;
    }
  `]
})
export class SupportTicketActivityRendererComponent implements ICellRendererAngularComp {
  label = '-';
  pillClass = '';

  agInit(params: ICellRendererParams): void {
    this.setValue(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.setValue(params);
    return true;
  }

  private setValue(params: ICellRendererParams): void {
    const value = (params?.value || '-').toString();
    this.label = value;
    this.pillClass =
      value === 'New reply' ? 'activity-new' :
      value === 'Pending reply' ? 'activity-pending' :
      value === 'Replied' ? 'activity-replied' : '';
  }
}
